import { filterStoreRepo } from 'components/Filters/FilterStore'
import FilterModal, {
  FilterGroup,
} from 'components/Filters/components/FilterModal'
import { FilterIdentifier } from 'models/saved_view'
import { EMAILS_COLUMNS } from './emailsColumnInfo'
import { createFilterColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { DateRangeFilter } from 'components/Filters/fields/DateRangeFilter'

export default function EmailsFilterset({
  filterIdentifier,
}: {
  filterIdentifier: FilterIdentifier
}) {
  const emailsFilterStore = filterStoreRepo.getStore(
    filterIdentifier as FilterIdentifier
  )

  const emailsFilterHelper = createFilterColumnHelper({
    columns: EMAILS_COLUMNS,
  })

  return (
    <FilterModal store={emailsFilterStore} identifier={filterIdentifier}>
      <FilterGroup title="Email">
        <DateRangeFilter
          {...emailsFilterHelper.retrieveProps('date')}
          filterStore={emailsFilterStore}
        />
      </FilterGroup>
    </FilterModal>
  )
}
